interface Step {
  title: string;
  description: string;
  note?: string;
}

interface StepGuideProps {
  steps: Step[];
  color?: 'green' | 'blue' | 'gray';
}

const colorMap = {
  green: { num: 'bg-primary-600 text-white', line: 'border-primary-200' },
  blue: { num: 'bg-[var(--slate)] text-white', line: 'border-[var(--slate)]' },
  gray: { num: 'bg-[var(--surface)] text-white', line: 'border-[var(--rule)]' },
};

export function StepGuide({ steps, color = 'green' }: StepGuideProps) {
  const c = colorMap[color];
  return (
    <ol className="space-y-0">
      {steps.map((step, i) => (
        <li key={i} className="flex gap-4">
          <div className="flex flex-col items-center flex-shrink-0">
            <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${c.num}`}>
              {i + 1}
            </div>
            {i < steps.length - 1 && <div className={`w-px flex-1 min-h-4 border-l-2 border-dashed my-1 ${c.line}`} />}
          </div>
          <div className={`pb-5 ${i === steps.length - 1 ? '' : ''}`}>
            <p className="text-sm font-semibold text-[var(--text-pri)] font-heading">{step.title}</p>
            <p className="text-sm text-[var(--text-sec)] mt-0.5 leading-relaxed">{step.description}</p>
            {step.note && (
              <p className="text-xs text-[var(--text-ter)] mt-1 bg-[var(--surface)] px-2 py-1 border border-[var(--rule)] inline-block">{step.note}</p>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
